import storage from 'store'
import {getCFileType,getArtlist,sortByID,findById,findParentPath,findElementById,modifyNestedArrayByKeyName,modifyClassElements,modifyNestedArrayById} from '@/utils/util'
import {ACCESS_TOKEN} from '@/store/mutation-types' 
import {getArticleClass} from '@/api/articleClass'
import {getItems,getComplexItems,getGlobalSearch,setMarkRead,getHomeV,getMyMessageList,setMarkAsRead,getUnreadCount} from '@/api/article'
import router from '../../router'



const article = {
  namespaced:true,
  state: {
	  
	menuList:[],
	seltMenuItem:[],
	defaultMenuItem:{id:2,name:"丹娜丝"},
	isFenPing:false,
	seltArtItem:{},
	seltArtItem2:{},
	msgList:[],
	artList:[],
	pplist:[],
	resData:[],
	resDataPre:[],
	resDataNext:[],
	
	
	resDataSearch:[],
	resDataPreSearch:[],
	resDataNextSearch:[],
	
	resDataDetail:[],
	
	page:1,
	pageSize:9,
	total:0,
	lastpage:0,
	lastpage2:1,//预览页用
	currentpage:0,
	
	searchKeyWords:"",
	searchKeyWordsMin:"",
	searchKeyWordsTop:"",
	
	activeDetailContent:"div1",
	leftHieght:0, 
	
	historyId:[],
	leftArtlist:[],
  },

  mutations: {
	//直接修改 state中的数据  //所有状态变更通过 mutation 完成。
	set_historyId:function(state,item){
		state.historyId=item;
	},
	set_menuList:function(state,item){
		state.menuList=item;
	},
	set_msgList:function(state,item){
		state.msgList=item;
	},
	set_artList:function(state,item){
		state.artList=item;
	},
	set_leftArtlist:function(state,item){
		state.leftArtlist=item;
	},
	set_pplist:function(state,item){
		state.pplist=item;
	},
	set_seltMenuItem:function(state,item){
		state.seltMenuItem=item;
	},
	set_defaultMenuItem:function(state,item){
		state.defaultMenuItem=item;		
		storage.set("defaultMenuItem",item, 24 * 60 * 60 * 1000)
	},
	set_seltArtItem:function(state,item){
		state.seltArtItem=item;
	},
	set_seltArtItem2:function(state,item){
		state.seltArtItem2=item;
	},
	  
	  set_isFenPing(state,item){
		  state.isFenPing=item
	  },
	  
	  
	set_page:function(state,item){
	  	state.page=item;
	},
	set_pageSize:function(state,item){
		state.pageSize=item;
	},
	set_total:function(state,item){
		state.total=item;
	},
	set_lastpage:function(state,item){
		state.lastpage=item;
	},
	set_lastpage2:function(state,item){
		state.lastpage2=item;
	},
	set_currentpage:function(state,item){
		state.currentpage=item;
	},	  
	
	SetResData:function(state,item){
		state.resData=item;
	},
	SetResDataPre:function(state,item){
		state.resDataPre=item;
	},	
	SetResDataNext:function(state,item){
		state.resDataNext=item;
	},
	SetSearchKeyWordsTop:function(state,item){
		state.searchKeyWordsTop=item;
	},
	
	SetResDataSearch:function(state,item){
		state.resDataSearch=item;
	},
	SetResDataPreSearch:function(state,item){
		state.resDataPreSearch=item;
	},	
	SetResDataNextSearch:function(state,item){
		state.resDataNextSearch=item;
	},
	
	SetSearchKeyWords:function(state,item){
		state.searchKeyWords=item;
	},
	SetSearchKeyWordsMin:function(state,item){
		state.searchKeyWordsMin=item;
	},
	
	SetActiveDetailContent:function(state,item){
		state.activeDetailContent=item;
	},
	SetLeftHieght:function(state,item){
		state.leftHieght=item;
	},
	
	SetResDataDetail:function(state,item){
		state.resDataDetail=item;
	},
	
	
  },

  actions: {
	  
    // 通过提交 mutation 间接修改
	async GetMenuList({rootState,commit,state})  {
	  
	  var userM=rootState.user; 
	  var parameter={token:userM.token};
	  var homeId=0;
	  await getHomeV(parameter).then(res2=>{
	  	homeId=res2.datas.id;
	  });
	  
      return new Promise((resolve, reject) => {
        getArticleClass(parameter)
          .then((res) => {
			////console.log("getArticleClass-res:",res);
            if (res.errcode !== 0) {
              reject(res.msg)
            }
			var pplist=[];	
			var seltPplist=state.pplist;
			var datas=res.datas;//sortByID(res.datas);				
			if(homeId>0)
			 {
				 var arr=findById(datas,homeId);
				 commit("set_defaultMenuItem",{id:arr.id,name:arr.name});
				 console.log("getHomeV:",{id:arr.id,name:arr.name});
			 }
			var defaultMenuItem=storage.get("defaultMenuItem");
			console.log("GetMenuList-defaultMenuItem:",defaultMenuItem,homeId,defaultMenuItem);
						
			//MenuPathList 只记录2级栏目
			var MenuPathList=[{id:datas[datas.length-1]['id'],name:datas[datas.length-1]['name']}];
			if(defaultMenuItem!=undefined && defaultMenuItem!=null)
			{
				 MenuPathList=findParentPath(datas,defaultMenuItem.id);
			}
			else
			{					
				var childItem=datas[datas.length-1];	
				defaultMenuItem=childItem;//没有缓存时，保存第一个；
				if(childItem['children']!=undefined && childItem['children'].length>0)
				{
					var dt=childItem['children'];
					var item2=dt[dt.length-1];
					//console.log("没有缓存时，dt-item2：",item2);
					MenuPathList.push({id:item2['id'],name:item2['name']});
					if(item2['children']!=undefined && item2['children'].length>0)
					{
						var dt3=item2['children'];
						var item3=dt3[dt3.length-1];
						defaultMenuItem=item3;
						//console.log("没有缓存时，dt3：",dt3);
						//console.log("没有缓存时，dt3-item：",item3);
						MenuPathList.push({id:item3['id'],name:item3['name']});
					}
				}
				console.log("没有缓存时，保存第一个的子集（==第3级第一个）：",defaultMenuItem,MenuPathList);
				//console.log("没有缓存时，保存第一个的子集（==第3级第一个） MenuPathList：",MenuPathList);
			}
			// //console.log("GetMenuList-defaultMenuItem-MenuPathList:",MenuPathList);
			// var r=findElementById(MenuPathList,2)
			// //console.log("GetMenuList-defaultMenuItem-MenuPathList-r2:",r);
			// r=findElementById(MenuPathList,36)
			// //console.log("GetMenuList-defaultMenuItem-MenuPathList-r36:",r);
			
			//datas=sortByID(datas);
			for(var i=0;i<datas.length;i++){
				datas[i]['icon']="caret-right";
				datas[i]['class']="";
				datas[i]['class2']="";
				datas[i]['title']=datas[i]['name']; //2025年  1级
				if(findElementById(MenuPathList,datas[i]['id'])!=undefined)
				{
					datas[i]['class']="active";
					datas[i]['icon']="caret-down";
					pplist.push({id:datas[i]['id'],name:datas[i]['name']});
				}
				
				var children=[];
				if(typeof datas[i]['children']!==undefined && datas[i]['children']!==null)
				{	
					children=datas[i]['children'];//sortByID(datas[i]['children']);
					for(var ii=0;ii<children.length;ii++)
					{
						children[ii]['icon']="caret-right";
						children[ii]['class']="";	
						children[ii]['class2']="";	
						children[ii]['class3']="";	 
						children[ii]['title']=children[ii]['name']; //丹娜丝 2级		
						var isDefaultMenuSubm=false;//展开默认项
						var twoObject=findElementById(MenuPathList,children[ii]['id']);
						if(twoObject!=undefined)
						{
							children[ii]['class']="active";
							children[ii]['icon']="caret-down";
							pplist.push({id:children[ii]['id'],name:children[ii]['name']});
						}	 					
						if(defaultMenuItem!=undefined && children[ii]['id']===defaultMenuItem.id)
						{
							children[ii]['class']="active";//add-right-icon  
							children[ii]['class2']="add-right-icon";
							isDefaultMenuSubm=true;
						}
						
						var sunzi=[];
						if(typeof children[ii]['children']!=="undefined" && children[ii]['children']!==null)
						{
							sunzi=children[ii]['children'];//sortByID(children[ii]['children']);
							for(var iii=0;iii<sunzi.length;iii++)
							{
								sunzi[iii]['icon']="caret-right";
								sunzi[iii]['class']="";	
								sunzi[iii]['class3']="";
								sunzi[iii]['title']=sunzi[iii]['name']; //随时更新  3级---实时更新
								if(isDefaultMenuSubm==true)
								{
									sunzi[iii]['class']="active";
									sunzi[iii]['icon']="caret-down";	
								}					
								if(iii==0 && twoObject!=undefined)
								{
									pplist.push({id:sunzi[iii]['id'],name:sunzi[iii]['name']});
								}								
								
								var zensunzi=[];
								if(typeof sunzi[iii]['children']!=="undefined" && sunzi[iii]['children']!==null)
								{
									zensunzi=sunzi[iii]['children'];//sortByID(sunzi[iii]['children']);
									for(var iiii=0;iiii<zensunzi.length;iiii++)
									{
										zensunzi[iiii]['icon']="caret-right";
										zensunzi[iiii]['class']="";	
										zensunzi[iiii]['class3']="";
										zensunzi[iiii]['title']=zensunzi[iiii]['name']; //4级  工作动态
										if(isDefaultMenuSubm==true)
										{
											zensunzi[iii]['class']="active";
											zensunzi[iii]['icon']="caret-down";
										}
										if(iiii==0 && twoObject!=undefined && findElementById(pplist,sunzi[iii]['id'])!=null)
										{
											pplist.push({id:zensunzi[iii]['id'],name:zensunzi[iii]['name'],ls:"test"});
										}
										var fourthZilei=[];
										if(typeof zensunzi[iiii]['children']!=="undefined" && zensunzi[iiii]['children']!==null)
										{											
											fourthZilei=zensunzi[iiii]['children'];//sortByID(zensunzi[iiii]['children']);
											for(var i5=0;i5<fourthZilei.length;i5++)
											{
												fourthZilei[i5]['icon']="caret-right";
												fourthZilei[i5]['class']="";	
												fourthZilei[i5]['class3']="";													
												fourthZilei[i5]['title']=fourthZilei[i5]['name']; //4级								
												if(isDefaultMenuSubm==true)
												{
													fourthZilei[i5]['class']="active";
													fourthZilei[i5]['icon']="caret-down";
												}
												if(findElementById(seltPplist,fourthZilei[i5]['id'])!=null)
												{
													fourthZilei[i5]['class3']="active3";
												}	
												if(i5==0 && twoObject!=undefined && findElementById(pplist,sunzi[iii]['id'])!=null && findElementById(pplist,zensunzi[iiii]['id'])!=null)
												{
													pplist.push({id:fourthZilei[i5]['id'],name:fourthZilei[i5]['name']});
												}	
																					
											}//end for									
										}//end if
										zensunzi[iiii]['children']=fourthZilei;	
										
									}//end for
								}//end if
								sunzi[iii]['children']=zensunzi;
							}//end for
						}//end if						
						children[ii]['children']=sunzi;
					}//end for
				}
				datas[i]['children']=children;
			}
			//console.log("menuList:",datas);
			////console.log("GetMenuList-defaultMenuItem-MenuPathList2:",MenuPathList);
			////console.log("GetMenuList-defaultMenuItem-pplist:",pplist);			
			datas=modifyClassElements(datas,"class",""); //展开所有层
			//console.log("menuList--------------:",datas);
			//class2  add-right-icon 
			datas=modifyNestedArrayByKeyName(datas,"class2","add-right-icon",function(node){
			  	node.class2=""
			});
			datas=modifyNestedArrayByKeyName(datas,"class3","active3",function(node){
				node.class3=" "
			});
			if(defaultMenuItem.id!=undefined && defaultMenuItem.id!=null)
			{			  	 
				 datas=modifyNestedArrayById(datas,defaultMenuItem.id,function(node){
				 	node.class2="add-right-icon"
					node.class3="active3"
				 });
				 pplist=findParentPath(datas,defaultMenuItem.id);
			}
			//console.log("GetMenuList-datas:",datas);
			
            commit('set_menuList',datas)
			if(state.seltMenuItem.id==undefined)
			{ 
				commit("set_pplist",pplist);
				commit("set_seltMenuItem",pplist[pplist.length-1]);
			}
			else{
				commit("set_pplist",state.pplist);
				commit("set_seltMenuItem",state.seltMenuItem);
			}
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
		  
		  
		  
		  
		  
      })
    }, 
	//设置默认目录
	setDefaultMenuItemAction({rootState,commit,state},params){
		commit("set_defaultMenuItem",params);
		storage.set("defaultMenuItem",params, 24 * 60 * 60 * 1000)
	},
	GetArticleList({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				page:params.page,
				page_size:(params.pageSize!=undefined?params.pageSize:state.pageSize),
				article_class_id:params.id,
				istype:params.istype,
			};
			
			if((params.istype=="curpage-detail" || params.istype=="prepage") && params.page<=0)
			{
				params.page=1;
			} 		
			if(params.key!=="undefined" && params.key!==null)
			{
				parameter.key=params.key;
			}
			var keywords=state.searchKeyWordsMin;
			if(keywords!==undefined && keywords!==null  && keywords!=="")
			{
				parameter.key=keywords;
				//parameter.article_class_id=0;
			}
			////console.log("parameter:",parameter);
			
			////console.log("GetArticleList-p:",parameter);
			getComplexItems(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					if(res.errcode==-1)
					{
						storage.remove(ACCESS_TOKEN)
						storage.remove("NextLogin");
						storage.remove("userinfor");
						router.push("/main");
					}
					reject(res.msg)
				  } 
				  var artlist=getArtlist(res.datas.data);
				  //console.log("GetArticleList-artlist.js-"+params.istype+":",artlist);
				  
				  if(params.istype=="curpage")
				  {
					  ////console.log("datas:",res.datas);
					  commit('SetResData',artlist)
					  commit('set_total',res.datas.total)
					  commit("set_lastpage",res.datas.last_page);
					  commit("set_currentpage",res.datas.current_page);					  
				  }		
				  if(params.istype=="curpage-detail")
				  {
					  commit('SetResData',artlist)
					  commit("set_lastpage2",res.datas.last_page);					  
					  if(res.datas.last_page==res.datas.current_page)
					  {
					  	console.log("curpage-detail 最后一页了");
					  }
				  }
				  if(params.istype=="prepage")
				  {
				  	 commit('SetResDataPre',artlist)				  
				  }				  
				  if(params.istype=="nextpage")
				  {
				  	 commit('SetResDataNext',artlist)				  
				  }		
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
		
	},
	GetDetailArticleList({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				page:params.page,
				page_size:(params.pageSize!=undefined?params.pageSize:state.pageSize),
				article_class_id:params.id,
				istype:params.istype,
			};
			
			if(params.page<=0)
			{
				params.page=1;
			} 		
			if(params.key!=="undefined" && params.key!==null)
			{
				parameter.key=params.key;
			}
			var keywords=state.searchKeyWordsMin;
			if(keywords!==undefined && keywords!==null  && keywords!=="")
			{
				parameter.key=keywords;
				//parameter.article_class_id=0;
			}
			getComplexItems(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					if(res.errcode==-1)
					{
						storage.remove(ACCESS_TOKEN)
						storage.remove("NextLogin");
						storage.remove("userinfor");
						router.push("/main");
					}
					reject(res.msg)
				  } 
				  var artlist=getArtlist(res.datas.data);
				  commit('SetResData',artlist)
				  res.datas.data=artlist;
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
		
	},
	
	
	
	GetArticleList2({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				page:params.page,
				page_size:(params.pageSize!=undefined?params.pageSize:state.pageSize),
				article_class_id:params.id,
				istype:params.istype,
			};
			
			if((params.istype=="curpage-detail" || params.istype=="prepage") && params.page<=0)
			{
				params.page=1;
			} 		
			if(params.key!=="undefined" && params.key!==null)
			{
				parameter.key=params.key;
			}
			var keywords=state.searchKeyWordsMin;
			if(keywords!==undefined && keywords!==null  && keywords!=="")
			{
				parameter.key=keywords;
				//parameter.article_class_id=0;
			}
			//console.log("parameter:",parameter);
			
			////console.log("GetArticleList-p:",parameter);
			getItems(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  } 
				  var artlist=getArtlist(res.datas.data);		
				  if(params.istype=="curpage-detail")
				  {
					  commit('SetResData',artlist)
				  }
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
		
	},
	GetGlobalSearch({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				key:params.key,
				page:params.page,
				page_size:params.pageSize,
				istype:params.istype,
			};
			//console.log("GetGlobalSearch-p-"+params.istype+":",parameter);
			
			getGlobalSearch(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  } 
				  var artlist=getArtlist(res.datas.data);
				  //console.log("GetGlobalSearch-artlist-"+params.istype+":",artlist);		
				  if(params.istype=="curpage")
				  {
					  ////console.log("datas:",res.datas);
					  commit('SetResDataSearch',artlist)
					  commit('set_total',res.datas.total)
					  commit("set_lastpage",res.datas.last_page);
					  commit("set_currentpage",res.datas.current_page);	
					  commit("set_page",res.datas.current_page);	 
				  }		
				  if(params.istype=="curpage-detail")
				  {
					  commit('SetResDataSearch',artlist)
					  commit('set_total',res.datas.total)
					  commit("set_lastpage",res.datas.last_page);
				  }		  
				  if(params.istype=="prepage")
				  {
				  	 commit('SetResDataPreSearch',artlist)				  
				  }				  
				  if(params.istype=="nextpage")
				  {
				  	 commit('SetResDataNextSearch',artlist)				  
				  }		
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
		
	},
	GetGlobalSearch2({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				key:params.key,
				page:params.page,
				page_size:params.pageSize,
				istype:params.istype,
			};
			//console.log("GetGlobalSearch-p-"+params.istype+":",parameter);
			
			getGlobalSearch(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  } 
				  var artlist=getArtlist(res.datas.data);
				  res.datas.data=artlist;
				  
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
		
	},
	
	SetMarkRead({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				id:params.id,
			};  
			setMarkRead(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  } 
				  var artlist=state.resData;
				   for(var i=0;i<artlist.length;i++)
				   {
					   if(artlist[i]['id']==params.id)
					   {
						   artlist[i]['read']=true;
						   artlist[i]['is_read']=true;
						   ////console.log("artlist[i]:",artlist[i]);
						   break;
					   }
				   }
				  commit('SetResData',artlist);
				  
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
	},
	
	SetMarkAsRead({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				//is_read_all:params.is_read_all==1?1:0,
				id_array:params.ids,
			};  
			if(params.is_read_all==1)
			{
				parameter.is_read_all=1;
			}
			setMarkAsRead(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  } 
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
	},
	MyMessageList({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
				page:params.page,
				page_size:params.pagesize,
			};  
			getMyMessageList(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  }
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
	},
	
	UnreadCount({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			var parameter={
				token:rootState.user.token,
			};  
			getUnreadCount(parameter).
				then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  }
				  resolve(res)
			}).catch(error => {reject(error)});
			
		});
	},
	
	
	getHomeAction({rootState,commit,state},params){
		return new Promise((resolve,reject)=>{
			
			var homeId=0;//homeId=res2.datas.id;
			var userM=rootState.user;
			var parameter={token:userM.token};
			getHomeV(parameter).then(res => { 
				  if (res.errcode !== 0){
					reject(res.msg)
				  }
				  resolve(res)
			}).catch(error => {reject(error)});
			
			
		});
	},
	
	
	
	resDataAction:function({commit})
	{
		commit("SetResData",[
	{
		id:1,
		title: '水利水位表（8日21时00分）',
		ftitle:"8月21日 00时 发布",
		type:"pdf",
		cat:"水利水位表",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC82LnBkZg%3D%3D",
		read:true
	},
	{
		 id:2,
		title: '台风“丹娜丝”避灾安置场所使用情况、转移',
		ftitle:"8月21日 00时 发布",
		cat:"避灾安置场所使用情况...",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC80LmRvY3g%3D",
		type:"xml"
	},
	{
		id:3,
		title: '平阳第4号台风“丹娜丝”防御工作动态...',
		ftitle:"7月8日 20时 发布",
		cat:"工作动态",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC8yLnhsc3g%3D",
		type:"word"
	},
	{
		  id:4,
		title: '14时 平阳县人员转移情况统计表-细分(2)',
		ftitle:"8月21日 14时 发布",
		cat:"人员转移统计表",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC8zLnhscw%3D%3D",
		type:"xml",
		read:true
	},
	{
		  id:5,
		title: '气象累计雨量图',
		ftitle:"8月21日 14时 发布",	
		cat:"气象累计雨量图",
		type:"pdf",
		read:false,
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC81LnBuZw%3D%3D"
	},
	{
		  id:6,
		title: 'Title 6',
		type:"dir"
	},
	{
		  id:7,
	  title: 'Title 7',
		type:"list"
	},
	{
		  id:8,
	  title: 'Title 8',
		type:"dir"
	},
	{
		  id:9,
	  title: 'Title 9',
		type:"dir"
	},
	{
		  id:10,
	  title: 'Title 10',
		type:"dir"
	},
	{
		  id:11,
	  title: 'Title 11',
		type:"dir"
	},
	{
		  id:12,
	  title: 'Title 12',
		ftitle:"8月21日 14时 发布",
		type:"pdf"
	},
	{
		  id:13,
	  title: 'Title 13',
		type:"dir"
	}]);
	},
	
	
	//跨模块访问 State
	fetchData({ rootState }) {
	    const userModuleData = rootState.user.name;
	},
	
	
	
  }
}

export default article